module.exports = __webpack_public_path__ + "img/6f1c9bd.jpg";